'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargeSend = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.9763 3.30005C4.51134 3.30005 3.33805 4.46524 3.33805 5.87792C3.33805 6.27976 3.44441 6.65004 3.60904 6.98249C3.61643 7.00679 3.62516 7.03072 3.63519 7.05417C3.66078 7.11397 3.68624 7.16353 3.70806 7.20305C3.72414 7.25823 3.74703 7.31147 3.77638 7.36148L6.08775 11.3L13 11.3C13.3866 11.3 13.7 11.6135 13.7 12C13.7 12.3866 13.3866 12.7 13 12.7L6.08997 12.7L3.79778 16.6059C3.73295 16.675 3.69131 16.7473 3.66468 16.8083C3.63573 16.8528 3.59382 16.9273 3.56693 17.0259C3.40463 17.3562 3.30005 17.7237 3.30005 18.1222C3.30005 19.5349 4.47333 20.7001 5.93829 20.7001C6.4953 20.7001 6.99204 20.5247 7.40559 20.2596L7.45449 20.2269L7.45672 20.2254L19.0478 14.3954C19.0596 14.3895 19.0713 14.3832 19.0828 14.3765C20.039 13.9925 20.7 13.0739 20.7 12.0064C20.7 10.9796 20.0885 10.0907 19.191 9.68258L7.44353 3.74063C7.02998 3.47554 6.53331 3.30005 5.9763 3.30005Z",
            fill: "currentColor"
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    d: "M7.30641 11.9937L4.38005 7.00714V6.96907C4.35471 6.91832 4.31671 6.86757 4.2787 6.77875V6.75337C4.12668 6.47423 4.038 6.18239 4.038 5.87787C4.038 4.86281 4.88678 4 5.97625 4C6.38163 4 6.74901 4.12688 7.06572 4.3299L7.10372 4.35527L7.14173 4.38065L18.7332 10.2427H18.7712L18.8092 10.2807C19.5186 10.5599 20 11.2324 20 12.0063C20 12.7803 19.5186 13.4528 18.8092 13.732H18.7712L18.7332 13.77L7.10372 19.6193L7.06572 19.6447L7.02771 19.6701C6.71101 19.8731 6.34363 20 5.93824 20C4.84877 20 4 19.1372 4 18.1221C4 17.8176 4.08868 17.5258 4.2407 17.2466V17.2213C4.2407 17.1959 4.26603 17.1705 4.2787 17.1578C4.2787 17.1324 4.30404 17.1197 4.30404 17.1071C4.30404 17.0944 4.30404 17.0817 4.31671 17.0817L4.34204 17.0563L4.36738 17.0182L7.29374 12.0317L7.30641 11.9937Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M7.30664 11.9935H13.02",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};

module.exports = LargeSend;
